import React, { useState, useEffect } from "react";
import {
  Stack,
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Button,
} from "@mui/material";
import { SecondaryButton } from "../../../../../Utils/ButtonHelper";
import * as BiIcons from "react-icons/bi";
import * as BsIcons from "react-icons/bs";
import OutletDetails from "./OutletDetails";
import { useHistory, Link, useParams, useLocation } from "react-router-dom";
import ShopWrapper from "../../ShopWrapper";
import { connect } from "react-redux";
import UnauthorisedAccess from "../../UnauthorisedAccess/UnauthorisedAccess";
import { useTranslation } from "react-i18next";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../../../api";
import { toast } from "material-react-toastify";

function InvoiceConfig({ shopAccessControl }) {
  const { t } = useTranslation();

  const history = useHistory();
  const location = useLocation();
  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  const { shopId, shopName, shopType } = useParams();

  const [id, setId] = useState("");
  const [prefix, setprefix] = useState("");
  const [suffix, setsuffix] = useState("");
  const [complementary, setcomplementary] = useState("NO");
  const [cancelled, setcancelled] = useState("NO");
  const [invoiceNumber, setinvoiceNumber] = useState(1);
  const [loader, setloader] = useState(false);

  const getConfig = () => {
    handleSpringDataRequest(`core/api/v1/shop-invoice/get?shopId=${shopId}`)
      .then((res) => {
        if (Object.entries(res).length > 0) {
          setId(res.id);
          setprefix(res.prefix);
          setsuffix(res.suffix);
          setcomplementary(res.complementary);
          setcancelled(res.cancelled);
          setinvoiceNumber(res.invoice_number);
        }
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  useEffect(() => {
    getConfig();
  }, []);

  const handleSave = () => {
    setloader(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/shop-invoice/create-update?shopId=${shopId}`,
      {
        id: id === "" ? null : id,
        hotelId: hotelId,
        shopId: shopId,
        prefix: prefix,
        suffix: suffix,
        invoiceNumber: invoiceNumber,
        complementary: complementary,
        cancelled: cancelled,
      }
    )
      .then((res) => {
        toast.success(t("Invoice configuration updated successfully"));
        getConfig();
        setloader(false);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setloader(false);
      });
  };

  return (
    <ShopWrapper
      contentArea={
        shopAccessControl &&
        shopAccessControl?.["POSAddUpdateShop"] &&
        JSON.parse(shopAccessControl?.["POSAddUpdateShop"])?.read === "YES" ? (
          <Stack className="position-relative w-100">
            <h3>Customised Shop Invoice Number</h3>
            <h6
              style={{ color: "gray", marginBottom: "2rem" }}
              className="mt-2 mb-3"
            >
              This page allows your property to configure a custom Shop Invoice
              Number format for shop bills using a prefix, suffix, and sequence
              number
            </h6>
            <div className="mt-4" style={styles.questionPadding}>
              <h4 style={{ width: "100%" }}>
                {t("Shop custom invoice prefix")}
              </h4>
              <div className="mb-2" style={{ width: "100%" }}>
                <TextField
                  label={t("Custom invoice prefix")}
                  className="input-lg w-100 mt-3"
                  placeholder={t("Enter prefix here")}
                  onChange={(e) => setprefix(e.target.value)}
                  value={prefix}
                  name="schedule_name"
                  id="schedule_name"
                />
              </div>
            </div>
            <div style={styles.questionPadding}>
              <h4 style={{ width: "100%" }}>
                {t("Shop custom invoice number sequence start?")}
              </h4>
              <div className="mb-2" style={{ width: "100%" }}>
                <TextField
                  label={t("Sequence Start")}
                  className="input-lg w-100 mt-3"
                  placeholder={t("Enter start sequence here")}
                  onChange={(e) => setinvoiceNumber(e.target.value)}
                  value={invoiceNumber}
                  name="schedule_name"
                  id="schedule_name"
                  type="number"
                />
              </div>
            </div>
            <div style={styles.questionPadding}>
              <h4 style={{ width: "100%" }}>
                {t("Shop custom invoice Suffix?")}
              </h4>
              <div className="mb-2" style={{ width: "100%" }}>
                <TextField
                  label={t("Suffix")}
                  className="input-lg w-100 mt-3"
                  placeholder={t("Enter suffix here")}
                  onChange={(e) => setsuffix(e.target.value)}
                  value={suffix}
                  name="schedule_name"
                  id="schedule_name"
                />
              </div>
            </div>
            <div style={styles.questionPadding}>
              <h4 style={{ width: "100%" }} className="mb-2">
                {t("Generate custom invoice number for complimentary orders?")}
              </h4>
              <FormControl fullWidth className="mt-4">
                <InputLabel id="demo-simple-select-label">
                  {t("Complimentary")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={(e) => setcomplementary(e.target.value)}
                  label={t("Complimentary")}
                  value={complementary}
                >
                  <MenuItem value={"YES"}>{"YES"}</MenuItem>
                  <MenuItem value={"NO"}>{"NO"}</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={styles.questionPadding}>
              <h4 style={{ width: "100%" }} className="mb-2">
                {t("Generate custom invoice number for cancelled orders?")}
              </h4>
              <FormControl fullWidth className="mt-4">
                <InputLabel id="demo-simple-select-label">
                  {t("Cancelled")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={(e) => setcancelled(e.target.value)}
                  label={t("Cancelled")}
                  value={cancelled}
                >
                  <MenuItem value={"YES"}>{"YES"}</MenuItem>
                  <MenuItem value={"NO"}>{"NO"}</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={styles.questionPadding}>
              <Button
                color="primary"
                className="float-right mr-4 mb-3"
                variant="custom-button"
                disabled={loader}
                onClick={handleSave}
                style={{ width: "3rem", marginLeft: "85%", marginTop: "2rem" }}
              >
                {loader ? (
                  <CircularProgress
                    size={15}
                    color="inherit"
                    sx={{ ml: 1.5 }}
                  />
                ) : (
                  `${t("Save")}`
                )}
              </Button>
            </div>
          </Stack>
        ) : (
          <UnauthorisedAccess />
        )
      }
    />
  );
}

// export default OutletConfiguration;
function mapStateToProps(state) {
  return {
    data: state.auth.selectedHotel,
    shopAccessControl: state.auth.shopAccessControl,
  };
}
export default connect(mapStateToProps)(InvoiceConfig);
const styles = {
  iconColor: {
    borderRadius: "100%",
    bordeRadius: "100%",
    height: "40px",
    width: "40px",
    padding: "4px",
    marginRight: "-10px",
    color: "#COCOCO",
  },
  inputSize: {
    width: "50px",
    bordeRadius: "5px",
    heigth: "30px",
  },
  questionPadding: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px ",
    width: "40%",
  },
};
